import React, { useState, useEffect } from "react";
import StyledOrder from "./StyledOrder";
import Select, { components } from "react-select";
import arrowNextWhite from "../../../assets/icons/arrowNextWhite.svg";
import CloseIcon from "../../../assets/icons/close.svg";
import { useHistory } from "react-router-dom";
import { App } from "../../../routes/Constants";
import QuitModal from "../../common/Modal/QuitModal";
import { ReactComponent as DropdownArrowDown } from "../../../assets/icons/dropdownArrowDown.svg";
import { ReactComponent as DropdownArrowUp } from "../../../assets/icons/dropdownArrowUp.svg";
import LocalStorage from "../../../shared/localStorage";
import moment from "moment";
import axios from "axios";
import APIVariables from "../../../services/api-variables";

import { Tabs, Tab } from "react-bootstrap";
import { handleCatch, isEmptyObject, isObject } from "../../../shared/helpers";
import { errorMessages } from "../../../constants/errorMessages.constants";
import PrescriberDetails from "./PrescriberDetails";
import SuccessModal from "./OrderSuccessModal";
import PharmacistConfirmation from "./PharmacistConfirmation";
import OutOfStockModal from "./OutOfStockModal";
import Footer from "../../common/Footer/Footer";
import ProductDescription from "./ProductDescription";

import MahLogo from "./MahLogo";
import MahButton from "./MahButton";
import MahValidateFields from "./MahValidateFields";

const Order = () => {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);
  const isEditOrder = window.location.pathname.includes("/edit");
  const pafID = isEditOrder
    ? window.location.pathname.split("/")[3]
    : window.location.pathname.split("/")[2];

  const history = useHistory();
  const [quitModalIsOpen, setIsOpenQuit] = useState(false);
  const [pharmacyUser, setPharmacyUser] = useState({});
  const [prescriberDetails, setPrescriberDetails] = useState({});
  const [registrarDetails, setRegistrarDetails] = useState({});
  const [prescription, setPrescription] = useState({});
  const [key, setKey] = useState("1");
  const [visibleTabs, setVisibleTabs] = useState({ tab2: false, tab3: false });
  const [form, setForm] = useState({
    confirmation_1: false,
    confirmation_2: false,
  });
  const [orderCyclesValuesTab1, setOrderCyclesValuesTab1] = useState({});
  const [orderCyclesValuesTab2, setOrderCyclesValuesTab2] = useState({});
  const [orderCyclesValuesTab3, setOrderCyclesValuesTab3] = useState({});
  const [prepopulatedOrderCycle, setPrepolulatedOrderCycle] = useState({
    tab1: false,
    tab2: false,
    tab3: false,
  });
  const [reorderCycle, setReorderCycle] = useState({
    tab1: false,
    tab2: false,
    tab3: false,
  });
  const [selectedTab, setSelectedTab] = useState({
    last: "",
    actual: "tab1",
  });

  const existsTab2 =
    +(prescription?.n_cycles && prescription?.n_cycles[0]) >= 2;
  const existsTab3 =
    +(prescription?.n_cycles && prescription?.n_cycles[0]) === 3;

  const isReordering = Object.values(reorderCycle).some((val) => val === true);
  const [errorMessageFromServer, setErrorMessageFromServer] = useState([]);
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [showStockModal, setShowStockModal] = useState({
    show: false,
    tab: null,
  });
  const [allowedReordering, setAllowedReordering] = useState({
    tab1: true,
    tab2: true,
    tab3: true,
  });
  const [mahs, setMahs] = useState([]);

  const getMAHs = async () => {
    await axios
      .get(process.env.REACT_APP_BASE_URL + APIVariables.MAHS, {
        headers: {
          Authorization: parseLocalStorage.token,
        },
      })
      .then((res) => {
        const { status, data } = res;
        if (status === 200) {
          setMahs(data);
        }
      })
      .catch((error) => {
        handleCatch(error);
      });
  };

  useEffect(() => {
    getMAHs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const preProcessMAHs = () => {
    const processedMAHs = [];

    mahs.forEach((mah) => {
      const sameMAH = processedMAHs.filter((i) => i.name === mah.name);

      if (sameMAH.length > 0) {
        if (Array.isArray(sameMAH[0].order_address)) {
          const existingAddress = sameMAH[0].order_address.find(
            (address) => address.label === mah.order_address
          );
          if (existingAddress) {
            existingAddress.pk = mah.id;
          } else {
            sameMAH[0].order_address.push({
              value: sameMAH[0].order_address.length,
              label: mah.order_address,
              pk: mah.id,
            });
          }
        } else {
          sameMAH[0].order_address = [
            { value: 0, label: sameMAH[0].order_address, pk: sameMAH[0].id },
            { value: 1, label: mah.order_address, pk: mah?.id },
          ];
        }

        if (Array.isArray(sameMAH[0].description)) {
          const existingDescription = sameMAH[0].description.find(
            (desc) => desc.value === mah.description
          );
          if (existingDescription) {
            existingDescription.id = mah.id;
          } else {
            sameMAH[0].description.push({
              id: sameMAH[0]?.description?.length,
              value: mah.description,
            });
          }
        } else {
          sameMAH[0].description = [
            {
              id: sameMAH[0].id,
              value: sameMAH[0].description,
            },
            { id: mah.id, value: mah.description },
          ];
        }
      } else {
        processedMAHs.push(mah);
      }
    });

    return processedMAHs;
  };

  const preProcessedMAHs = preProcessMAHs(mahs);
  const getMAHDescription = (id, selectedVal) => {
    if (
      typeof orderCycleDistributor?.[selectedTab.actual].description ===
      "object"
    ) {
      const mah = mahs.filter((i) => i.id === selectedVal?.pk);

      return typeof mah[0]?.description === "object"
        ? mah[0]?.description.filter((i) => i.id === selectedVal?.pk)[0]?.value
        : mah[0]?.description;
    } else {
      const mah = mahs.filter((i) => i.id === id);
      return typeof mah[0]?.description === "object"
        ? mah[0]?.description.filter((desc) => desc.id === id)[0].value
        : mah[0]?.description;
    }
  };

  const [orderCycleDistributor, setOrderCycleDistributor] = useState({
    tab1: { ...preProcessedMAHs },
    tab2: { ...preProcessedMAHs },
    tab3: { ...preProcessedMAHs },
  });
  const [displaySuccessModal, setDisplaySuccessModal] = useState(false);

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
    },
  };

  const [isSubmit, setIsSubmit] = useState(false);

  useEffect(() => {
    getPharmacyUser();
    getPrescriptionData(pafID);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Promise.all([prescription]).then(([res]) => {
      if (isEditOrder) {
        getOrderData();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prescription]);

  const prepopulateDrugDistributor = (
    populatedTab1,
    populatedTab2,
    populatedTab3,
    order_cycle
  ) => {
    let tabInfo;
    let allowedReordering = {};

    if (populatedTab1) {
      tabInfo = order_cycle[0];
      if (!tabInfo.allowReorder) {
        allowedReordering.tab1 = false;
      }

      if (preProcessedMAHs) {
        setOrderCycleDistributor((prevState) => ({
          ...prevState,
          tab1: {
            ...tabInfo,
          },
        }));
      }
    }

    if (populatedTab2) {
      tabInfo = order_cycle[1];
      if (!tabInfo.allowReorder) {
        allowedReordering.tab2 = false;
      }

      if (preProcessedMAHs) {
        setOrderCycleDistributor((prevState) => ({
          ...prevState,
          tab2: {
            ...tabInfo,
          },
        }));
      }
    }

    if (populatedTab3) {
      tabInfo = order_cycle[2];
      if (!tabInfo.allowReorder) {
        allowedReordering.tab3 = false;
      }
      if (preProcessedMAHs) {
        setOrderCycleDistributor((prevState) => ({
          ...prevState,
          tab3: {
            ...tabInfo,
          },
        }));
      }
    }

    setAllowedReordering((prevState) => ({
      ...prevState,
      ...allowedReordering,
    }));
  };

  const handleSelectChange = (value) => {
    setOrderCycleDistributor((prevState) => ({
      ...prevState,
      [selectedTab.actual]: {
        ...prevState[selectedTab.actual],
        id: value.pk,
        order: { label: value.label, pk: value.pk, value: value.value },
      },
    }));
  };

  const getOrderData = async () => {
    const orderFormID = window.location.pathname.split("/")[4];
    await axios
      .get(
        process.env.REACT_APP_BASE_URL + APIVariables.ORDERS_VIEW + orderFormID,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .then((res) => {
        const { status, data } = res;
        if (status === 200) {
          let formData = {
            ...data,
            confirmation_1: true,
            confirmation_2: true,
          };

          // SET VISIBLE TABS
          const visibleTabsCopy = {
            ...visibleTabs,
            ...(data.n_cycles >= 2 && { tab2: true }),
            ...(data.n_cycles === 3 && { tab3: true }),
          };

          const populatedTab1 = !!data.order_cycle[0];
          const populatedTab2 = !!data.order_cycle[1];
          const populatedTab3 = !!data.order_cycle[2];

          setVisibleTabs(visibleTabsCopy);
          handleSelectedTab("tab1");

          // SET ORDER CYCLE
          if (populatedTab1) {
            setOrderCyclesValuesTab1(data.order_cycle[0]);
            clickOnTab("tab2");
            handleSelectedTab("tab2");

            const isVisibleTabIfOrderFormHas2Cycles =
              prescription?.n_cycles && prescription?.n_cycles === "2 Cycles";

            const isVisibleTabIfOrderFormHas3Cycles =
              prescription?.n_cycles && prescription?.n_cycles === "3 Cycles";

            if (isVisibleTabIfOrderFormHas2Cycles) {
              setVisibleTabs({ ...visibleTabs, tab2: true, tab3: false });
            }

            if (isVisibleTabIfOrderFormHas3Cycles && !populatedTab2) {
              setVisibleTabs({ ...visibleTabs, tab2: true, tab3: false });
            }
          }
          if (populatedTab2) {
            setOrderCyclesValuesTab2(data.order_cycle[1]);
            clickOnTab("tab3");
            handleSelectedTab("tab3");

            if (prescription?.n_cycles === "2 Cycle") {
              setVisibleTabs({ ...visibleTabs, tab3: true });
            }
          }
          if (populatedTab3) {
            setOrderCyclesValuesTab3(data.order_cycle[2]);
          }

          setPrepolulatedOrderCycle({
            tab1: populatedTab1,
            tab2: populatedTab2,
            tab3: populatedTab3,
          });

          prepopulateDrugDistributor(
            populatedTab1,
            populatedTab2,
            populatedTab3,
            data.order_cycle
          );

          setForm(formData);
        }
      })
      .catch((err) => {
        handleCatch(err);
      });
  };

  const getPrescriptionData = async (order) => {
    const res = await axios
      .get(
        process.env.REACT_APP_BASE_URL + APIVariables.PRESCRIPTIONS_GET + order,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      )
      .catch(function (error) {
        handleCatch(error);
      });

    if (res?.status === 200) {
      res.data.prescriber
        ? setPrescriberDetails({ ...res.data.prescriber })
        : setRegistrarDetails({ ...res.data.registrar });
      let temp = { ...res.data };
      delete temp.prescriber;

      setPrescription({ ...temp });
    }
  };

  const getPharmacyUser = () => {
    setPharmacyUser({
      gmsNumber: parseLocalStorage?.pharmacy?.registration_number,
      email: parseLocalStorage.email,
      phone_number: parseLocalStorage.phone_number,
    });
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          {props.selectProps.menuIsOpen ? (
            <DropdownArrowUp />
          ) : (
            <DropdownArrowDown />
          )}
        </components.DropdownIndicator>
      )
    );
  };

  const [selectedMah, setSelectedMah] = useState();

  const handleChangess = (mah) => {
    setSelectedMah(mah);

    setOrderCycleDistributor((prevState) => ({
      ...prevState,
      [selectedTab.actual]: {
        ...mah,
      },
    }));
  };

  function quitModal() {
    history.push(App.DASHBOARD);
  }

  function closeForm() {
    setIsOpenQuit(true);
  }

  function closeModalQuit() {
    setIsOpenQuit(false);
  }

  const handleChangeNumberOfPacks = (selectedElement, name, tabNumber) => {
    if (tabNumber === "tab1") {
      const formCopy = {
        ...orderCyclesValuesTab1,
        [name]: selectedElement.value,
      };

      setOrderCyclesValuesTab1(formCopy);
    }

    if (tabNumber === "tab2") {
      const formCopy = {
        ...orderCyclesValuesTab2,
        [name]: selectedElement.value,
      };

      setOrderCyclesValuesTab2(formCopy);
    }

    if (tabNumber === "tab3") {
      const formCopy = {
        ...orderCyclesValuesTab3,
        [name]: selectedElement.value,
      };

      setOrderCyclesValuesTab3(formCopy);
    }
  };

  const displayIndication = () => {
    if (!prescription?.indication?.includes("Other")) {
      return prescription?.indication;
    } else {
      return "Other (" + prescription?.indication_other + ")";
    }
  };

  const displayTab = (e, tabNr, isAdd) => {
    e.preventDefault();
    if (tabNr === "tab2" && isAdd === false) {
      clickOnTab("tab1");
      setOrderCyclesValuesTab2({});
      setOrderCycleDistributor((prevState) => ({
        ...prevState,
        tab2: {},
      }));
    }

    if (tabNr === "tab3" && isAdd === false) {
      clickOnTab("tab2");
      setOrderCyclesValuesTab3({});
      setOrderCycleDistributor((prevState) => ({
        ...prevState,
        tab3: {},
      }));
    }

    const copyVisibleTabObj = { ...visibleTabs, [tabNr]: isAdd };
    setVisibleTabs(copyVisibleTabObj);
    if (!isAdd) {
      clickOnTab(getPreviousTab(tabNr), 100);
    } else {
      if (tabNr === "tab2" && isAdd === true) {
        clickOnTab("tab2");
      }
      if (tabNr === "tab3" && isAdd === true) {
        clickOnTab("tab3");
      }
    }
  };

  const getPreviousTab = (tab) => {
    let tabNo = parseInt(tab.slice(-1) ?? 0);

    if (!existsTab3) {
      return tabNo === 1 ? `tab2` : `tab1`;
    } else {
      if (tabNo === 1) {
        return isDisabledTab(`tab2`) ? `tab3` : `tab2`;
      }
      if (tabNo === 2) {
        return isDisabledTab(`tab3`) ? `tab1` : `tab3`;
      }
      if (tabNo === 3) {
        return isDisabledTab(`tab2`) ? `tab1` : `tab2`;
      }
    }
    return `tab1`;
  };

  const handleChangeCheckBox = (e) => {
    const { name, checked } = e.target;

    setForm((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const countRowsOrderCycles = () => {
    let count = 0;

    if (prescription.capsule_cycle_5 || prescription.capsule_cycle_other_5) {
      count = count + 1;
    }
    if (prescription.capsule_cycle_10 || prescription.capsule_cycle_other_10) {
      count = count + 1;
    }
    if (prescription.capsule_cycle_15 || prescription.capsule_cycle_other_15) {
      count = count + 1;
    }
    if (prescription.capsule_cycle_20 || prescription.capsule_cycle_other_20) {
      count = count + 1;
    }
    if (prescription.capsule_cycle_25 || prescription.capsule_cycle_other_25) {
      count = count + 1;
    }
    return count;
  };

  const displayedOrderCyclesValue = (tabNumber, value) => {
    return tabNumber === "tab1"
      ? !!orderCyclesValuesTab1[value]
        ? {
            value: orderCyclesValuesTab1[value] || null,
            label: `${orderCyclesValuesTab1[value]}` || null,
          }
        : ""
      : tabNumber === "tab2"
      ? orderCyclesValuesTab2[value]
        ? {
            value: orderCyclesValuesTab2[value],
            label: `${orderCyclesValuesTab2[value]}`,
          }
        : ""
      : orderCyclesValuesTab3[value]
      ? {
          value: orderCyclesValuesTab3[value],
          label: `${orderCyclesValuesTab3[value]}`,
        }
      : "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isDisabledTab = (tab) => {
    if (tab === "tab1") {
      return prepopulatedOrderCycle.tab1 && isEditOrder && !reorderCycle.tab1;
    }
    if (tab === "tab2") {
      const disabled =
        prepopulatedOrderCycle.tab2 && isEditOrder && !reorderCycle.tab2;
      return reorderCycle.tab2 ? disabled : disabled || !visibleTabs?.tab2;
    }
    if (tab === "tab3") {
      const disabled =
        prepopulatedOrderCycle.tab3 && isEditOrder && !reorderCycle.tab3;
      return reorderCycle.tab3 ? disabled : disabled || !visibleTabs?.tab3;
    }
    return false;
  };

  const setOrderCycle = () => {
    const array_order_cycle = [];
    if (!isEmptyObject(orderCyclesValuesTab1) && !isDisabledTab("tab1")) {
      array_order_cycle.push({ ...orderCyclesValuesTab1, tab: "tab1" });
    }
    if (!isEmptyObject(orderCyclesValuesTab2) && !isDisabledTab("tab2")) {
      array_order_cycle.push({ ...orderCyclesValuesTab2, tab: "tab2" });
    }
    if (!isEmptyObject(orderCyclesValuesTab3) && !isDisabledTab("tab3")) {
      array_order_cycle.push({ ...orderCyclesValuesTab3, tab: "tab3" });
    }
    return array_order_cycle;
  };

  const submitForm = async () => {
    setIsSubmit(true);
    if (areAllFieldsValid) {
      let sentCycles = setOrderCycle();
      sentCycles.forEach((cycle) => {
        let distributors = orderCycleDistributor[cycle.tab];
        let marketingholder;
        Object.keys(distributors)?.forEach((key) => {
          if (distributors[key]) {
            if (distributors.marketing_holder) {
              marketingholder = +distributors.marketing_holder;
            } else {
              marketingholder = distributors.id;
            }
          }
        });

        cycle.isReordering = reorderCycle[cycle.tab];
        cycle.marketing_holder = marketingholder;

        delete cycle.tab;
      });
      const orderItems = {
        prescription_id: pafID,
        // order_address: takeOrder(),
        pharmacist_name: form.pharmacist_name,
        created_date: moment().format("YYYY-MM-DD"),
        confirmation_1: form.confirmation_1,
        confirmation_2: form.confirmation_2,
        order_cycle: sentCycles,
      };

      const orderID = window.location.pathname.split("/")[4];
      const API = isEditOrder
        ? APIVariables.ORDERS_EDIT + orderID
        : APIVariables.ORDERS_CREATE;
      const methodType = isEditOrder ? "put" : "post";
      setDisabledSubmit(true);

      const res = await axios[methodType](
        process.env.REACT_APP_BASE_URL + API,
        orderItems,
        {
          headers: {
            Authorization: parseLocalStorage.token,
          },
        }
      ).catch(function (error) {
        handleCatch(error);

        setDisabledSubmit(false);
        const errors = error?.response?.data;
        if (typeof errors === "string") {
          setErrorMessageFromServer([errorMessages.INTERNAL_SERVER_ERROR]);
        } else {
          const errorsArray = [];
          if (!!errors) {
            Object.keys(errors).forEach((key) => {
              if (isObject(errors[key])) {
                Object.keys(errors[key]).forEach((secondKey) => {
                  errorsArray.push(errors[key][secondKey][0]);
                });
              } else {
                errorsArray.push(errors[key]);
              }
            });
            setErrorMessageFromServer(errorsArray);
          } else {
            setErrorMessageFromServer([error.message]);
          }
        }
      });

      if (res?.status === 200) {
        setDisplaySuccessModal(true);
        setDisabledSubmit(false);
      }
    }
  };

  const closeSuccessModal = () => {
    setDisplaySuccessModal(false);
    history.push(App.DASHBOARD);
  };

  const getTabContent = (tab) => (
    <div className="wrapper-tab flex-between">
      <div className="fullwidth">
        <div className="font-size-18 gray bold">Product Description</div>
        <div
          className="row mt-2"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <div className="col-md-3 prescriber-details-inputs gray">
            Capsule Strength:
          </div>
          <div className="col-md-3 prescriber-details-inputs aqua-deep">
            Total Capsules:
          </div>
          <div className="col-md-6 prescriber-details-inputs aqua-deep">
            <div className="flex-style">
              <span
                className={
                  `aqua-deep ` +
                  ((isSubmit &&
                    !validateFields().number_of_packs_1.isValid &&
                    selectedTab.actual === "tab1") ||
                  (isSubmit &&
                    !validateFields().number_of_packs_2.isValid &&
                    selectedTab.actual === "tab2") ||
                  (isSubmit &&
                    !validateFields().number_of_packs_3.isValid &&
                    selectedTab.actual === "tab3")
                    ? "red-label"
                    : "")
                }
                style={{ width: "58%" }}
              >
                Number of Pack(s):*
              </span>
              <span>
                (When the number of capsules required exceeds 21, select 2
                packs)
              </span>
            </div>
          </div>
        </div>
        <ProductDescription
          tabNumber={tab}
          displayedOrderCyclesValue={displayedOrderCyclesValue}
          handleChangeNumberOfPacks={handleChangeNumberOfPacks}
          prescription={prescription}
          DropdownIndicator={DropdownIndicator}
          prepopulatedOrderCycle={prepopulatedOrderCycle}
          reorderCycle={reorderCycle}
          key={`product_description_${tab}`}
        />
      </div>
    </div>
  );

  const enableTabForReorder = (tab) => {
    setShowStockModal({ show: true, tab: tab });
  };

  const activateReorder = (tab) => {
    setReorderCycle((prevState) => ({
      ...prevState,
      [tab]: true,
    }));

    setVisibleTabs({ ...visibleTabs, [tab]: true });
    handleSelectedTab(tab);
    clickOnTab(tab);
  };

  const handleSelectedTab = (tab) => {
    if (tab !== selectedTab.actual) {
      let newSelectedTab = {};
      newSelectedTab.last = selectedTab.actual;
      newSelectedTab.actual = tab;
      setSelectedTab({ ...newSelectedTab });
    }
  };

  const clickOnTab = (tab, time = 0) => {
    setTimeout(() => {
      if (
        document.getElementById(
          `controlled-tab-example-${tab?.slice(0, -1)}-${tab?.slice(-1)}`
        )
      ) {
        document
          .getElementById(
            `controlled-tab-example-${tab?.slice(0, -1)}-${tab?.slice(-1)}`
          )
          .click();
      }
    }, time);
  };

  const handleCancelReorder = (tab) => {
    setReorderCycle((prevState) => ({
      ...prevState,
      [tab]: false,
    }));
    clickOnTab(selectedTab.actual);
  };

  const closeStockModal = () => {
    setShowStockModal(false);
  };

  const handlePharmaNameFromModal = (nameFromModal) => {
    setForm((prevState) => ({
      ...prevState,
      pharmacist_name: nameFromModal,
    }));
  };

  const canReorder = (tab) => {
    switch (tab) {
      case "tab1":
        return (
          prepopulatedOrderCycle.tab1 &&
          isEditOrder &&
          !reorderCycle.tab1 &&
          allowedReordering.tab1
        );
      case "tab2":
        return (
          prepopulatedOrderCycle.tab2 &&
          isEditOrder &&
          !reorderCycle.tab2 &&
          allowedReordering.tab2
        );
      case "tab3":
        return (
          prepopulatedOrderCycle.tab3 &&
          isEditOrder &&
          !reorderCycle.tab3 &&
          allowedReordering.tab3
        );
      default:
        return false;
    }
  };

  const canCancelReorder = (tab) => {
    switch (tab) {
      case "tab1":
        return (
          prepopulatedOrderCycle.tab1 &&
          isEditOrder &&
          reorderCycle.tab1 &&
          !(selectedTab.actual === "tab1")
        );
      case "tab2":
        return (
          prepopulatedOrderCycle.tab2 &&
          isEditOrder &&
          reorderCycle.tab2 &&
          !(selectedTab.actual === "tab2")
        );
      case "tab3":
        return (
          prepopulatedOrderCycle.tab3 &&
          isEditOrder &&
          reorderCycle.tab3 &&
          !(selectedTab.actual === "tab3")
        );
      default:
        return false;
    }
  };

  const shouldEnableAddDelete = (tab) => {
    switch (tab) {
      case "tab1":
        return false; //tab1 doesn't have Add / Remove options, because it is mandatory to have at least 1 cycle
      case "tab2":
        return (
          (!visibleTabs.tab3 && !prepopulatedOrderCycle.tab1) ||
          (isReordering &&
            !reorderCycle.tab2 &&
            !prepopulatedOrderCycle.tab2 &&
            (isDisabledTab("tab3") || prepopulatedOrderCycle.tab3))
        );
      case "tab3":
        return !canReorder("tab3") && !reorderCycle.tab3;
      default:
        return false;
    }
  };

  const validateFieldsOrderCycle1 =
    Object.keys(orderCyclesValuesTab1).length >= countRowsOrderCycles();
  const validateFieldsOrderCycle2 =
    Object.keys(orderCyclesValuesTab2).length >= countRowsOrderCycles();
  const validateFieldsOrderCycle3 =
    Object.keys(orderCyclesValuesTab3).length >= countRowsOrderCycles();

  const validateFields = () => ({
    select_distributor_tab_1: {
      isValid: Object.values(orderCycleDistributor.tab1).some(
        (element) => element
      ),
    },

    select_distributor_email_1: {
      isValid:
        typeof orderCycleDistributor.tab1.order_address === "string"
          ? !!orderCycleDistributor.tab1.order_address
          : !!orderCycleDistributor.tab1.order,
    },
    select_distributor_tab_2: {
      isValid:
        visibleTabs.tab2 || canReorder("tab2")
          ? Object.values(orderCycleDistributor.tab2).some((element) => element)
          : true,
    },
    select_distributor_email_2: {
      isValid:
        visibleTabs.tab2 || canReorder("tab2")
          ? typeof orderCycleDistributor.tab2.order_address === "string"
            ? orderCycleDistributor.tab2.order_address
            : orderCycleDistributor.tab2.order
          : true,
    },
    select_distributor_tab_3: {
      isValid:
        visibleTabs.tab3 || canReorder("tab3")
          ? Object.values(orderCycleDistributor.tab3).some((element) => element)
          : true,
    },
    select_distributor_email_3: {
      isValid:
        visibleTabs.tab3 || canReorder("tab3")
          ? typeof orderCycleDistributor.tab3.order_address === "string"
            ? orderCycleDistributor.tab3.order_address
            : orderCycleDistributor.tab3.order
          : true,
    },
    number_of_packs_1: {
      isValid:
        !isEmptyObject(orderCyclesValuesTab1) && validateFieldsOrderCycle1,
    },
    number_of_packs_2: {
      isValid:
        visibleTabs.tab2 || canReorder("tab2")
          ? Object.keys(orderCyclesValuesTab2).length !== 0 &&
            validateFieldsOrderCycle2
          : true,
    },
    number_of_packs_3: {
      isValid:
        visibleTabs.tab3 || canReorder("tab3")
          ? Object.keys(orderCyclesValuesTab3).length !== 0 &&
            validateFieldsOrderCycle3
          : true,
    },
    pharmacist_confirmation_1: {
      isValid: form.confirmation_1,
    },
    pharmacist_confirmation_2: {
      isValid: form.confirmation_2,
    },
    pharmacist_name: {
      isValid:
        (!!form?.order_cycle &&
          form?.order_cycle[selectedTab.actual]?.pharmacist_name?.length > 0) ||
        form.pharmacist_name?.length > 0,
    },
  });

  const areAllFieldsValid = Object.values(validateFields()).every((field) => {
    return field.isValid;
  });

  const displayInRedMarketingHolder = (
    prop_1,
    prop_2,
    prop_3,
    custom_class = "red-label"
  ) => {
    const isSelectedDistributorFromFirstPage =
      isSubmit &&
      selectedTab.actual === "tab1" &&
      !validateFields()[prop_1].isValid;

    const isSelectedDistributorFromSecondPage =
      isSubmit &&
      selectedTab.actual === "tab2" &&
      !validateFields()[prop_2].isValid;

    const isSelectedDistributorFromThirdPage =
      isSubmit &&
      selectedTab.actual === "tab3" &&
      !validateFields()[prop_3].isValid;

    return isSelectedDistributorFromFirstPage ||
      isSelectedDistributorFromSecondPage ||
      isSelectedDistributorFromThirdPage
      ? custom_class
      : "";
  };

  const disable_ = () => {
    // When all tabs are prepopulated and no one of it is reordering (all the tabs are disabled)
    const areAllTabsPrepopulatedAndDisabled =
      prepopulatedOrderCycle.tab1 &&
      prepopulatedOrderCycle.tab2 &&
      prepopulatedOrderCycle.tab3 &&
      !(reorderCycle.tab1 || reorderCycle.tab2 || reorderCycle.tab3);

    if (!isEditOrder) {
      return false;
    } else if (areAllTabsPrepopulatedAndDisabled) {
      return true;
    } else {
      const tab_1 = visibleTabs.tab1 ? !canReorder("tab1") : false;
      const tab_2 = visibleTabs.tab2 ? !canReorder("tab2") : false;
      const tab_3 = visibleTabs.tab3 ? !canReorder("tab3") : false;

      return !(tab_1 || tab_2 || tab_3);
    }
  };

  const selectedBrand =
    !disable_() &&
    (orderCycleDistributor?.[selectedTab.actual]?.name ||
      orderCycleDistributor?.[selectedTab.actual]?.marketing_holder_name);

  const getMahId =
    +orderCycleDistributor?.[selectedTab.actual].marketing_holder ||
    +orderCycleDistributor?.[selectedTab.actual]?.id;

  const mahDescription =
    !disable_() &&
    getMAHDescription(
      getMahId,
      !!orderCycleDistributor?.[selectedTab.actual].order
        ? orderCycleDistributor?.[selectedTab.actual].id &&
            orderCycleDistributor?.[selectedTab.actual].order
        : null
    );
  const formatedMahDescription =
    !!mahDescription &&
    mahDescription?.split(/\r\n\r\n|\r\n|\n/g)?.map((paragraph, index) => (
      <div className="mt-4 font-size-16" key={index}>
        {paragraph}
      </div>
    ));

  return (
    <StyledOrder>
      <div className="layout-modal ">
        <div className="close-icon" onClick={closeForm}>
          <img src={CloseIcon} alt="Close Icon" />
        </div>
        <h1>Please Complete the Order Form</h1>
        <hr className="mt-3 green-hr" />
        <div className="wrapper-order font-size-16">
          Orders cannot be processed unless this form is fully completed. Once a
          Lenalidomide brand is selected an order is generated to the nominated
          distributor.
          <div className="second-title mt-5 aqua-deep">
            Lenalidomide Supplier Selection
          </div>
          <div
            className={
              `mt-4 font-size-16 ` +
              displayInRedMarketingHolder(
                "select_distributor_tab_1",
                "select_distributor_tab_2",
                "select_distributor_tab_3"
              )
            }
          >
            Please select the Marketing Authorisation Holder of the Lenalidomide
            product you are ordering:
          </div>
          <div className="select-marketing mt-4">
            <div className="buttons_container select-marketing">
              {preProcessedMAHs.map((mah, index) => {
                return !!mah.logo ? (
                  <MahLogo
                    selected={
                      !disable_() &&
                      (orderCycleDistributor?.[selectedTab.actual]
                        .marketing_holder_name === mah.name ||
                        orderCycleDistributor?.[selectedTab.actual].name ===
                          mah.name)
                    }
                    src={mah.logo}
                    alt={mah.name}
                    key={`mah_logo_${index}`}
                    onClick={() => !disable_() && handleChangess(mah)}
                    className={disable_() && `disabled`}
                  />
                ) : (
                  <MahButton
                    selected={
                      !disable_() &&
                      (orderCycleDistributor?.[selectedTab.actual]
                        .marketing_holder_name === mah.name ||
                        orderCycleDistributor?.[selectedTab.actual].name ===
                          mah.name)
                    }
                    text={mah.name}
                    key={`mah_button_${mah.name}_${index}`}
                    onClick={() => !disable_() && handleChangess(mah)}
                    className={disable_() && `disabled`}
                  />
                );
              })}
            </div>
          </div>
          <div className="second-title mt-5 aqua-deep">
            Email Notification to Drug Distributor
          </div>
          <div>
            {!disable_() &&
            Object.keys(orderCycleDistributor[selectedTab.actual]).length ===
              0 ? (
              <input
                className="dove-gray "
                value={""}
                disabled
                placeholder="Please select an MAH"
              />
            ) : !disable_() &&
              typeof orderCycleDistributor[selectedTab.actual]
                ?.order_address === "string" ? (
              <input
                className={disable_() ? "disabled" : "dove-gray "}
                value={orderCycleDistributor[selectedTab.actual]?.order_address}
                disabled
                placeholder="Please select an MAH"
              />
            ) : (
              <Select
                classNamePrefix={
                  displayInRedMarketingHolder(
                    "select_distributor_email_1",
                    "select_distributor_email_2",
                    "select_distributor_email_3",
                    "custom-select-red "
                  ) + `custom-select`
                }
                components={{
                  DropdownIndicator: DropdownIndicator,
                  IndicatorSeparator: () => null,
                }}
                onChange={handleSelectChange}
                value={orderCycleDistributor[selectedTab.actual]?.order}
                isDisabled={disable_()}
                options={
                  typeof selectedMah?.order_address === "string"
                    ? orderCycleDistributor[selectedTab.actual]?.order_address
                    : selectedMah?.order_address
                }
                placeholder="Select Email Notification to Drug Distributor"
              />
            )}

            <>{formatedMahDescription}</>
          </div>
          <div className="mt-5 font-size-16 gray bold">
            Nominated Pharmacy Address
          </div>
          <div className="mt-2">
            <input
              className="dove-gray-only"
              value={prescription?.pharmacy_address || ""}
              disabled
            />
          </div>
          <PrescriberDetails
            prescription={prescription}
            prescriberDetails={prescriberDetails}
            registrarDetails={registrarDetails}
            displayIndication={displayIndication}
          />
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
              !isDisabledTab(`tab${k}`) && setKey(k);
              !isDisabledTab(`tab${k}`) && handleSelectedTab(`tab${k}`);
            }}
            className="mb-3"
          >
            <Tab
              eventKey="1"
              as={"ul"}
              title={
                <React.Fragment>
                  {canReorder("tab1") && (
                    <div
                      className="reorder-cycle-style"
                      onClick={() => enableTabForReorder("tab1")}
                    >
                      Reorder Cycle 1
                    </div>
                  )}
                  {canCancelReorder("tab1") && (
                    <div
                      className="remove-cycle-style white-text"
                      onClick={() => handleCancelReorder("tab1")}
                    >
                      Reordering
                    </div>
                  )}
                  <div
                    className={
                      prepopulatedOrderCycle.tab1 &&
                      isEditOrder &&
                      !reorderCycle.tab1
                        ? "prepopulated-tab-name"
                        : "simple-tab"
                    }
                  >
                    Order Cycle 1
                  </div>
                </React.Fragment>
              }
              tabClassName={
                prepopulatedOrderCycle.tab1 && isEditOrder && !reorderCycle.tab1
                  ? "prepopulated-tab"
                  : ""
              }
              disabled={false}
            >
              {getTabContent("tab1")}
            </Tab>
            {existsTab2 && (
              <Tab
                eventKey="2"
                title={
                  <React.Fragment>
                    {canReorder("tab2") && (
                      <div
                        className="reorder-cycle-style"
                        onClick={() => enableTabForReorder("tab2")}
                      >
                        Reorder Cycle 2
                      </div>
                    )}
                    {canCancelReorder("tab2") && (
                      <div
                        className="remove-cycle-style white-text"
                        onClick={() => handleCancelReorder("tab2")}
                      >
                        Reordering
                      </div>
                    )}
                    {shouldEnableAddDelete("tab2") && (
                      <React.Fragment>
                        {visibleTabs.tab2 ? (
                          <div
                            className="remove-cycle-style reorder-cycle-style"
                            onClick={(e) => {
                              displayTab(e, "tab2", false);
                              setSelectedMah();
                            }}
                          >
                            Remove
                          </div>
                        ) : (
                          <div
                            className="reorder-cycle-style add-cycle-style"
                            onClick={(e) => {
                              displayTab(e, "tab2", true);
                              setSelectedMah(null);
                            }}
                          >
                            Add
                          </div>
                        )}
                      </React.Fragment>
                    )}
                    <div
                      className={
                        prepopulatedOrderCycle.tab2 &&
                        isEditOrder &&
                        !reorderCycle.tab2
                          ? "prepopulated-tab-name"
                          : "simple-tab"
                      }
                    >
                      Order Cycle 2
                    </div>
                  </React.Fragment>
                }
                tabClassName={
                  prepopulatedOrderCycle.tab2 &&
                  isEditOrder &&
                  !reorderCycle.tab2
                    ? "prepopulated-tab"
                    : ""
                }
                disabled={false}
              >
                {getTabContent("tab2")}
              </Tab>
            )}
            {existsTab3 && (
              <Tab
                eventKey="3"
                title={
                  <React.Fragment>
                    {canReorder("tab3") && (
                      <div
                        className="reorder-cycle-style"
                        onClick={() => enableTabForReorder("tab3")}
                      >
                        Reorder Cycle 3
                      </div>
                    )}
                    {canCancelReorder("tab3") && (
                      <div
                        className="remove-cycle-style white-text"
                        onClick={() => handleCancelReorder("tab3")}
                      >
                        Reordering
                      </div>
                    )}
                    {shouldEnableAddDelete("tab3") && (
                      <>
                        {visibleTabs?.tab3
                          ? (!isEditOrder ||
                              (isEditOrder && isReordering) ||
                              !isDisabledTab("tab2")) && (
                              <div
                                className="remove-cycle-style reorder-cycle-style"
                                onClick={(e) => {
                                  displayTab(e, "tab3", false);
                                  setSelectedMah();
                                }}
                              >
                                Remove
                              </div>
                            )
                          : selectedTab.actual === "tab2" && (
                              <div
                                className="add-cycle-style reorder-cycle-style"
                                onClick={(e) => {
                                  displayTab(e, "tab3", true);
                                }}
                              >
                                Add
                              </div>
                            )}
                      </>
                    )}

                    <div
                      className={
                        prepopulatedOrderCycle.tab3 &&
                        isEditOrder &&
                        !reorderCycle.tab3
                          ? "prepopulated-tab-name"
                          : "simple-tab"
                      }
                      disabled={false}
                    >
                      Order Cycle 3
                    </div>
                  </React.Fragment>
                }
                tabClassName={
                  prepopulatedOrderCycle.tab3 &&
                  isEditOrder &&
                  !reorderCycle.tab3
                    ? "prepopulated-tab"
                    : ""
                }
              >
                {getTabContent("tab3")}
              </Tab>
            )}
            <Tab
              tabClassName="custom-selected-brand"
              title={
                <div>
                  <div className="select-brand">Selected Brand:</div>
                  <div className="brand">{selectedBrand}</div>
                </div>
              }
            ></Tab>
          </Tabs>
          <p className="font-size-14">
            If a distributor informs you that the brand of lenalidomide you
            selected is out of stock, please select the appropriate Reorder
            cycle above.
          </p>
          <PharmacistConfirmation
            form={form}
            handleChangeCheckBox={handleChangeCheckBox}
            isEditOrder={isEditOrder}
            pharmacyUser={pharmacyUser}
            handleChange={handleChange}
            validateFields={validateFields()}
            isSubmit={isSubmit}
            isOrderCycleDisableLogic={!disable_()}
            selectedBrand={selectedBrand}
          />
          {(errorMessageFromServer || []).map((item) => (
            <div className="red-text">{item}</div>
          ))}
          <div className="row mt-5">
            <div className="col aqua-deep font-size-16"></div>
            <div className="col submit-container">
              <MahValidateFields
                validateFields={validateFields}
                isSubmit={isSubmit}
              />
              <button
                className="primary-button"
                onClick={() => submitForm()}
                // disabled={disableSubmit()}
                disabled={disable_() || disabledSubmit}
              >
                Submit <img src={arrowNextWhite} alt="Arrow Right" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {displaySuccessModal && (
        <SuccessModal
          displaySuccessModal={displaySuccessModal}
          customStyles={customStyles}
          closeSuccessModal={closeSuccessModal}
        />
      )}
      {showStockModal.show && (
        <OutOfStockModal
          showStockModal={showStockModal}
          customStyles={customStyles}
          closeModal={closeStockModal}
          handlePharmaNameFromModal={handlePharmaNameFromModal}
          activateReorder={activateReorder}
        />
      )}
      {quitModalIsOpen && (
        <QuitModal
          quitModalIsOpen={quitModalIsOpen}
          closeModalQuit={closeModalQuit}
          quitModal={quitModal}
          description="Are you sure you want to cancel filling out this form? All progress will be lost and you will need to start again."
        />
      )}
      <Footer />
    </StyledOrder>
  );
};

export default Order;
